import { Link } from 'react-router-dom';
import LogoLight from 'src/assets/images/logos/jojo-logo-transparent.png';

const Logo = ({ height = 50 }) => {
  return (
    <Link to="/">
      <img
        src={LogoLight}
        alt="Logo"
        style={{
          maxWidth: '100%',
          height: 'auto',
          maxHeight: height,
          objectFit: 'contain',
          display: 'block',
        }}
      />
    </Link>
  );
};

export default Logo;
